module.exports = "images/teamed_image_01.png";